import { ContainerComponent, wrap } from 'AppReact';
import controller from './controller';
import internalState from './internalState';
import { OrderEventWrapper, FullWidthFlexBoxJustifyCenterWrapper, Mr2, Mt2 } from 'wrappers';
import { TextButton } from 'molecules';
import { PrimaryTextXs, PrimaryTextXsBold, NoteText } from 'atoms';
import { getEventData } from 'utils';
import { getNoteText } from 'utils';

export const definition = {
  name: 'OrderEvent',
  controller,
  initialProps: ({ order_event, inspectionId }) => ({ order_event, inspectionId }),
  props: { ...internalState },
  renderIf: ({ order_event }) => !!order_event,
  elements: [
    {
      wrapper: FullWidthFlexBoxJustifyCenterWrapper,
      name: 'Wrapper',
      elements: [
        {
          component: wrap(PrimaryTextXsBold, Mr2),
          name: 'BoldText',
          displayValue: ({ }) => 'Work order created'
        },
        {
          component: wrap(PrimaryTextXs, Mr2),
          name: 'TimeStamp',
          displayValue: ({ order_event }) => getEventData(order_event).timeStamp ?? ''
        },
        {
          component: PrimaryTextXs,
          name: 'Creator',
          displayValue: ({ order_event }) => `${getEventData(order_event).by ?? ''} from inspection`
        },
      ]
    },
    {
      component: wrap(NoteText, Mt2),
      name: 'Description',
      displayValue: ({ order_event }) => getNoteText(order_event.description ?? '')
    },
    {
      component: wrap(TextButton, Mt2),
      name: 'Button',
      bindings: ({ inspectionId }) => ({ mobileSmall: true, inspectionId, title: 'See inspection' })
    },
  ]
};

export default wrap(ContainerComponent(definition), OrderEventWrapper);
